// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoriesList_category___oVX6","categoryLink":"CategoriesList_categoryLink__5TSyJ"};